<template>
    <div class="row-section">
        <div class="lightblue home-row">
            <div class="row-left">
                Deep domain expertise.<br/><br/>
                World leading capabilities.<br/>
            </div>
            <div class="lightblue-row-right">
                EPIWATCH<sup>®</sup> was developed by world-renowned experts in epidemics, pandemics and emerging infections, and is underpinned by extensive, peer-reviewed research. Our tools reflect our extensive expertise.<br/> <br/>
                Our software team continually improves our AI systems, working closely with our epidemiologists to evaluate, test and train the system. Our analysts review and validate data daily, ensuring you receive highly curated intelligence.
            </div>
        </div>
        <div class="dark-blue home-row-title">
            <div class="darkblue-section">
                <div class="darkblue-title">
                    <div class="darkblue-text">Our Services</div>
                </div>
                <div class="darkblue-left">EPIWATCH<sup>®</sup> is an early warning system for epidemics, pandemics and other health events. We provide highly curated data that is globally representative.</div>
            </div>
            <div class="darkblue-section img0" style="height: 500px;"/>
            <div class="map-img-2" src="/home/home_view.png" style="height: 500px;" v-if="!mobile"></div>
            <!-- <img  class="map-img-2" src="/home/home_view.png" alt="Image of the Epiwatch Dashboard"/> -->
            <!-- </div> -->
        </div>
        <div class="home-row vertical-center" style="padding-right: 0px;" >
            <div class="row-text" style="padding-right: 50px">
                <div class="row-title">
                    Virtual Command and Control Centre with advanced data visualization.
                </div>
                <div class="row-p">
                    EPIWATCH<sup>®</sup> provides a dashboard with advanced data visualisation, at your finger tips. The system can ingest other data streams or can be set up in your own system.
                </div>
            </div>
            <div class="row-img-right-container">
                <div class="row-img-right img1">
                </div>
            </div>
        </div>
        <div class="home-row lightblue vertical-center" style="padding-left: 0%;">
            <div class="row-img-left img2" v-if="!mobile">
            </div>
            <div class="row-text" style="padding-left: 50px">
                <div class="row-title">
                    A range of real-time decision support tools to meet your needs.
                </div>
                <div class="row-p">
                    Our world-leading expertise in epidemics has informed the development of a range of real time tools to support response and mitigation of epidemic threats. 
                </div>
            </div>
                        <div class="row-img-left-container">

            <div class="row-img-left img2" v-if="mobile">
            </div>

            </div>
        </div>
        <div class="home-row vertical-center" style="padding-right: 0px;">
            <div class="row-text" style="padding-right: 50px">
                <div class="row-title">
                    On-demand and custom risk analytic and modelling tools
                </div>
                <div class="row-p">
                    We have drawn on our established scientific track record in epidemiology, modelling and risk analysis to provide you real-time self-serve or bespoke solutions.
                </div>
            </div>
            <div class="row-img-right-container">
                <div class="row-img-right img3">
                </div>

            </div>
        </div>
        <div class="home-row lightblue vertical-center" style="padding-left: 0%;">
            <div class="row-img-left img4" v-if="!mobile">
            </div>
            <div class="row-text" style="padding-left: 50px">
                <div class="row-title">
                    Custom analysis of outbreaks and health events
                </div>
                <div class="row-p">
                    We can provide rapid analysis of urgent health events to inform your policy and practice.
                </div>
            </div>
                                    <div class="row-img-left-container">

            <div class="row-img-left img4" v-if="mobile">
                </div>
            </div>
        </div>
        
        <div class="home-row-title contact-background  ">
            <div style="flex: 9;">
                <div class="darkblue-title contact-title">
                    
                    <div class="darkblue-text">Contact Us</div>
                </div>
                <div class="darkblue-left">EPIWATCH<sup>®</sup> is an early detection system designed to identify epidemics, pandemics, CBRN and various health emergencies before they spread widely. We deliver carefully selected, high-quality data with comprehensive global coverage.<br/><br/> 

                Contact us today to find out more.</div>
            </div>
            <div style="flex: 3; text-align: center;">
            <v-btn x-large class="blue-button" to="/contact" style="margin-right: 20px; float: left;">
                    
                    <img src="/home/marker.svg" width="15%" style="margin-right: 15px;" alt="marker"/>
                Contact Us
          </v-btn>
            </div>
        </div>

    </div>

</template>
<script>
  export default {
    name: "RowSection",
    data: () => ({
        mobile: null
    }) ,
    mounted() {
        this.checkScreen();
    },
    methods: {
        checkScreen() {
        this.windowWidth = window.innerWidth;
        if (this.windowWidth <= 600) {
        this.mobile = true;
        } else {
        this.mobile = false;
        }
    }
    }

  }
</script>